import { useLocalStorage, useSessionStorage } from '@vueuse/core'
import { defineStore } from 'pinia'
import type { Channel, Language } from '~/graphql/operations'

interface LocalStorageAuth {
  authToken?: string
  refreshToken?: string
  user?: {
    id: number
    email: string
    name?: string
    defaultChannelId?: number
    languageId?: number
    permissions?: string[]
    channels?: number[]
    userChannels: {
      id: number
      defaultLanguageId: number
      name: string
    }[]
  }
}

export const useMainStore = defineStore('main', () => {
  const filters = useSessionStorage('filters', [])
  const sorts = useSessionStorage('sorts', [])
  function getPageFilters(path: String) {
    return filters.value.find((f) => f.path === path)?.filters
  }

  function addPageFilters(filter: { path: String; filters: Object }) {
    const i = filters.value?.findIndex((f) => f.path === filter?.path)

    if (i !== -1) {
      filters.value[i] = filter
    } else {
      filters.value.push(filter)
    }
  }
  function getPageSorts(path: String) {
    return sorts.value.find((s) => s.path === path)?.sorts
  }
  function addPageSorts(sort: { path: String; sorts: Object }) {
    const i = sorts.value?.findIndex((s) => s.path === sort?.path)

    if (i !== -1) {
      sorts.value[i] = sort
    } else {
      sorts.value.push(sort)
    } 
  }

  return {
    channel: useChannel(),
    currentChannels: ref([]),
    channels: useSessionStorage<Channel[]>('channels', []),
    languages: useSessionStorage<Language[]>('languages', []),
    loading: ref(false),
    auth: useLocalStorage<LocalStorageAuth>('auth', {
      authToken: null,
      user: null,
    }),
    filters,
    sorts,
    getPageFilters,
    addPageFilters,
    getPageSorts,
    addPageSorts
  }
})
